import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "@/components/NavBar";
import SEOHead from "@/components/SEOHead";
import { Home, HelpCircle, Image, Eraser, BookOpen } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  const links = [
    { to: "/", icon: Home, label: "Compresor de Imágenes", desc: "Comprime JPG, PNG, WebP gratis" },
    { to: "/quitar-fondo", icon: Eraser, label: "Quitar Fondo", desc: "Elimina fondos con IA" },
    { to: "/blog", icon: BookOpen, label: "Blog y Guías", desc: "Aprende a optimizar imágenes" },
    { to: "/faq", icon: HelpCircle, label: "Preguntas Frecuentes", desc: "Respuestas a dudas comunes" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <SEOHead
        title="Página no encontrada | CompresorJPEG"
        description="La página que buscas no existe. Visita nuestro compresor de imágenes gratuito o explora nuestras herramientas."
        noindex={true}
      />
      <NavBar />

      <main className="container mx-auto px-4 py-20">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <Image className="h-20 w-20 mx-auto text-gray-300 mb-4" />
            <h1 className="text-6xl font-bold text-gray-800 mb-3">404</h1>
            <p className="text-xl text-gray-600 mb-2">Página no encontrada</p>
            <p className="text-gray-500">
              La ruta <code className="bg-gray-100 px-2 py-1 rounded text-sm">{location.pathname}</code> no existe.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="flex items-start gap-3 p-4 bg-white/80 rounded-xl hover:shadow-md transition-shadow text-left"
              >
                <link.icon className="h-6 w-6 text-blue-600 mt-0.5 shrink-0" />
                <div>
                  <div className="font-semibold text-gray-800">{link.label}</div>
                  <div className="text-sm text-gray-500">{link.desc}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
